import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from '../service/user.service';

export const AdminGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);
  const user = userService.loggedUser();

  if (user && user.isAdmin) {
    return true;
  }

  router.navigate(['/my-catalog']);
  return false;
};
